import Bury from '@/common/bury.js';

export default {
  components: {},
  props: {},
  data() {
    return {};
  },

  beforeRouteEnter(to, from, next) {
    console.log(to);
    let buryId = Bury.buryAdd({ functionType: '用户行为', logType: '页面浏览', startData: { s1: to.meta.code, s2: from.meta.code, code: to.meta.code } });
    to.meta.buryId = buryId;

    console.log(buryId, to.meta.name);

    next();
  },
  beforeRouteLeave(to, from, next) {
    console.log(to.meta.buryId, from.meta.buryId);
    1;
    Bury.buryUpdateById(from.meta.buryId, { e1: to.meta.name, e2: from.meta.name });
    next();
  }
};
